import DevLog from '../../devlog/Module'
import ViewportModule from '../../viewport/Module'
import PreviewModule from '../../preview/Module'
import errorAction from '../../../actions/error/errorAction'
import transferActionProps from '../transferActionProps'
import { doPost } from '../doPost'

import { IAction, SurveyMode } from '../../../actions/types'
import { ModuleID } from '../../types'
import { IErrorResponse, IRequestChangeQuotaBody } from '../types'

import { DEBUG_CLIENT } from '../const'
import { getURLfromAction } from '../lib'

export default async function requestChangeQuota(fromAction: IAction, mode: SurveyMode, target: number) {
  const body: IRequestChangeQuotaBody = {
    device: ViewportModule.viewport.device,
    mode: mode,
    proxy_params: {},
    payload: { name: 'set_quota', target }
  }

  if (DEBUG_CLIENT) {
    DevLog._log(`SW[${ModuleID.CLIENT}]:`, 'requestChangeQuota', body)
  }

  let nextAction = errorAction({ ...fromAction, mode })
  try {
    const response = await doPost<IAction | IErrorResponse>(
      getURLfromAction(fromAction, PreviewModule.resetURL),
      body
    ).catch(error => {
      DevLog.error(`SW[${ModuleID.CLIENT}]:`, 'requestChangeQuota', String(error as string), error)
      return errorAction({ ...fromAction, mode })
    })
    nextAction =
      'error' === (response as IErrorResponse).status ? errorAction({ ...fromAction, mode }) : (response as IAction)
  } catch (error) {
    DevLog.error(`SW[${ModuleID.CLIENT}]:`, 'requestChangeQuota', String(error as string), error)
  }

  return transferActionProps(fromAction, nextAction)
}
